import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
 import type { Ref } from 'vue'
 import { useSubmit } from './FormMixin'
 import { useRoute } from 'vue-router'
 import {
   passwordSet,
  } from '@/services/auth.service'
  
import useGlobal from '@/composables/useGlobal'


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordSet',
  props: ['idCrypt', 'userToken'],
  emits: ['changeForm'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

 
 
 const props = __props

const emit = __emit
const { $t } = useGlobal()
const load = ref(false) 
const dataIsSended = ref(false)
const nonFieldErrors = ref("")
const email = ref("")
const password = ref(null)
const password1 = ref(null)

const toResetForm = () => {
  emit('changeForm', true)
}

const request = (sendData: any, control: any) => {
  useSubmit( send(sendData, control), control)
}

const toAuthForm = () => {
  window.location.href = '/'
}

const send = async (sendData: any, control: any) => {
  try {
      load.value = true
      const { redirectLink } = (await passwordSet.execute({}, {
        ...sendData,
        idCrypt: props.idCrypt,
        userToken: props.userToken,
      }))
      dataIsSended.value = true
      load.value = false
  } catch (e) {
    load.value = false
    return Promise.reject(e)
  }
}
  
const __returned__ = { props, emit, $t, load, dataIsSended, nonFieldErrors, email, password, password1, toResetForm, request, toAuthForm, send, ref, get useSubmit() { return useSubmit }, get useRoute() { return useRoute }, get passwordSet() { return passwordSet }, get useGlobal() { return useGlobal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})